import React, { useState } from 'react';
import { Container, Accordion } from "react-bootstrap";
import classes from '../pages.module.css';
import TextCol from "../../components/Ui/text/textCol";
import BtnDownload from '../../components/Ui/button/btnDownload';
import ListList from '../../components/Ui/list/listList';

const LmOTN = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Конвергенция всего трафика через OTN, включая низкоскоростные сервисы'},
        {id:2, content: 'Не имитация SDH, а настоящий E1oOTN'},
        {id:3, content: 'Полная совместимость с существующим оборудованием'},
        {id:4, content: 'Полный вывод из эксплуатации любого оборудования SDH / PDH'},
        {id:5, content: 'Не влияет на CPE или SLA клиента'},
        {id:6, content: 'Полная инфраструктура OTN / WDM с огромным увеличением емкости, минимальной задержкой и сохранением синхронизации'},
    ])
    const [lists, setlists] = useState([
        {id:1, list: 'Линейные порты: 10G OTU2 B&W или C/DWDM (SFP+ based)'},
        {id:2, list: 'Клиентские порты:Dual STM-1/4/16/64, 1GE, 10GE, OTU1/2, FC, etc. (SFP/SFP+)'},
        {id:3, list: 'Переключающая ёмкость: ODU0/1/2/Flex granularity'},
        {id:4, list: 'Питание: -48V'},
        {id:5, list: 'Синхронизация: 2 МГц / 2 Мбит, 1PPS / TOD'},
        {id:6, list: 'Резервирование матрицы и контроллера: EPS'},
        {id:7, list: 'Резервирование питания: EPS'},
        {id:8, list: 'L2 Сервисы: прозрачный P2P, EPL, EVPL ETree'},
        {id:9, list: 'Сетевое соединение: ODU0 / 1/2 / Flex однонаправленная/двунаправленная защита'},
        {id:10, list: 'Резервирование трафика: ODU0 / 1/2 / Flex SNC'},
        {id:11, list: 'Резервирование клиентов: Multiblade LAG, MSP'},
        {id:12, list: 'Функции PKT: Классификации, Политики, Очереди (QoS based), VLAN mng, OAM'},
        {id:13, list: 'Синхронизация: SDH синхронизация, SyncE, PTP 1588v2'},
        {id:14, list: 'Performance Monitoring: OTN, PKT'},
        {id:15, list: 'Протокол управления SDN: RESTCONF / Yang согласован с моделью ONF'}
    ])
    const [lists1, setlists1] = useState([
        {id:1, list: 'Линейные порты: OTU4 B&W (QSFP28 based) или DWDM (Coherent – CFP2 DCO based)'},
        {id:2, list: 'Клиентские порты: Dual STM-1/4/16/64, 1GE, 10GE, OTU1/2, FC, etc. (SFP/SFP+)'},
        {id:3, list: 'Переключающая ёмкость: ODU0/1/2/Flex granularity'},
        {id:4, list: 'Питание: -48V'},
        {id:5, list: 'Синхронизация: 2MHz/2Mbit, 1PPS/TOD'},
        {id:6, list: 'Резервирование матрицы и контроллера: EPS'},
        {id:7, list: 'Резервирование питания: EPS'},
        {id:8, list: 'Сетевое соединение: ODU0/1/2/Flex unidir/bidir/D&C protection'},
        {id:9, list: 'Резервирование трафика: ODU0/1/2/Flex SNC'},
        {id:10, list: 'Резервирование клиентов: MSP'},
        {id:11, list: 'Синхронизация: SDH sync, SyncE, 1588v2 (PTP)'},
        {id:12, list: 'Performance Monitoring: OTN, PKT'},
        {id:13, list: 'Протокол управления SDN: RESTCONF/Yang в соответствии с моделью ONF'}
    ])
    return(
        <>
            <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>оборудование для оптических сетей</span>
                        <h1>LM-1 OTN</h1>
                        <p>Уникальное оборудование операторского класса и полностью защищенная платформа для передачи каналов 10/100/200G в сегментах доступа или городской сети с неограниченными возможностями и гибкостью, для передачи различных типов трафика в одной сети с лучшими характеристиками с точки зрения пропускной способности и задержки. Собственная SDN технология обеспечивает гибкую и быструю подготовку для работы с непредсказуемыми матрицами трафика, управляемыми современными платформами оркестратора SDN. Система операторского класса с полным резервированием - с аппаратной защитой клиентских и сетевых интерфейсов обеспечивает максимальную надежность.
LM-1 OTN 10G и LM-1 OTN 100G предлагают полную функциональность OTN-коммутационной сети и интегрированную функциональность L2-агрегации в одном юните (1RU).</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' />
            <Container fluid="md">
                <div className={classes.accordinBlock}>
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>LM-1 OTN 10G</Accordion.Header>
                            <Accordion.Body>
                                <ListList lists={lists} />
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>LM-1 OTN 100G</Accordion.Header>
                            <Accordion.Body>
                                <ListList lists={lists1} />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </>
    )
}

export default LmOTN;